import { useAppDispatch } from "store";
import { sandboxActionInvoked } from "store/features";
import { SvgAdd } from "@itwin/itwinui-icons-react";
import styles from "./SandboxCreateTile.module.css";

export const SandboxCreateTile = () => {
  const dispatch = useAppDispatch();

  const onClick = () => {
    dispatch(sandboxActionInvoked({ type: "create" }))
  }

  return (
    <div className={["iui-tile", "iui-actionable", styles.sandboxCreate].join(" ")} onClick={onClick} data-testid="atp-sandbox-create-tile">
      <SvgAdd />
    </div>
  )
}